export default "__VITE_ASSET__6JodshFc__"